import { IllumioEventEmitter } from "../common/event_emitter.js";
import IllumioDomUtils from "../common/dom_utils.js";
import { AssetListingModel, AssetListingView, AssetListingController } from "./asset-listing-mvc.js";

/**********************************************************************
 * CommonSoftare MVC 
 * These objects are designed for JavaScript inheritance. 
 * Do NOT instantiate and use them directly.
 *********************************************************************/

export class CommonSoftwareModel extends IllumioEventEmitter {
    constructor(filename) {
        super();

        this.filename = filename;
        
        // this.dataLoadEvent = new IllumioEvent(this);
        
        // To be initialized upon successful API call.
        this.success = false;
        this.metadata = null;
        this.data = null;
        this.error = null;
        
        // Track the version to be displayed.
        // To be set by the children class prior to rendering downloads.
        this.displayVersions = null;
        
        this.dataLoadingStatus = 'Initial'; // Possible status: Initial, Loading, Success, Failed
        
        if (this.filename) {
            var url = `/api/v1/software/${this.filename}.json`;
            console.debug(`CommonSoftwareModel: loading: ${url}`);
            $.ajax({
                dataType: 'json',
                method: 'get',
                contentType: 'application/json; charset=utf-8',
                url: url,
                beforeSend: this.ajaxBeforeSendHandler.bind(this),
                error: this.ajaxErrorHandler.bind(this),
                success: this.ajaxSuccessHandler.bind(this),
            });
        }
    }
    
    ajaxBeforeSendHandler(jqXHR, settings) {
        this.dataLoadingStatus = 'Loading';
    }
    
    ajaxSuccessHandler(data, textStatus, jqXHR) {
        this.dataLoadingStatus = 'Loaded';
        
        this.success = data.success;
        if (this.success) {
            this.metadata = data.metadata;
            this.data = data.data;
        } else {
            this.error = data.error;
        }
        console.debug(`CommonSoftwareModel: Successfully loaded ${this.filename}.json`);
        
        // console.debug(data);
        // console.debug(textStatus);
        // console.debug(jqXHR);
        
        // this.dataLoadEvent.notify();
        this.emit('loadData', {});
    }
    
    ajaxErrorHandler(jqXHR, textStatus, errorThrown) {
        this.dataLoadingStatus = 'Failed';
        
        this.success = false;
        this.error = {
            status: jqXHR.status,
        }
        if (jqXHR.status == '403') {
            this.error.message = 'Our records indicate that you do not have access to this page. If you need access to additional resources, please contact the Illumio owner within your organization to create a support case and we can grant you additional access.'
        } else {
            this.error.message = 'The resource is currently offline for unscheduled maintenance. Please try again later. [' + jqXHR.status + ']'

        }
        
        console.error('CommonSoftwareModel: Error in loading ${this.filename}.json');
        console.warn(textStatus);
        console.debug(errorThrown);
        console.debug(jqXHR);
        
        // this.dataLoadEvent.notify();
        this.emit('loadData', {});
    }
    
        getAsset(assetId) {
            if (assetId && this.data && this.data.software_components) {
                for (var i=0;i<this.data.software_components.length;i++) {
                    if (this.data.software_components[i].id===assetId) {
                        return this.data.software_components[i];
                    }
                }
            }
            
            return null;
        }
}

export class CommonSoftwareView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;
        this.model.on('loadData', this.modelDataLoadEventHandler.bind(this));
        // this.model.dataLoadEvent.attach(modelDataLoadEventHandler.bind(this));
        
        // this.renderDownloadsEvent = new IllumioEvent(this);

        this.elements = null;
    }
    
    modelDataLoadEventHandler() {
        this.render();
    }
    
    renderError() {
        console.warn('CommonSoftwareView: renderError()');
        
        if (this.model.error.status>0) {
            const elementNames = Object.keys(this.elements);
            const elementNamesForEachHandler = function(name) {
                if (name==='error') {
                    this.elements[name].classList.remove('hidden');
                } else {
                    this.elements[name].classList.add('hidden');
                }
            }
            elementNames.forEach(elementNamesForEachHandler.bind(this));
            
            IllumioDomUtils.removeChildren(this.elements['error']);
            const messageElement = document.createElement('p');
            messageElement.textContent = this.model.error.message;
            this.elements['error'].appendChild(messageElement);
        } else {
            // Do not show the error message if the status is 0.
        	// One of the possible reason of 0 is AJAX loading is interrupted.
        	console.warn('renderError(): status of 0 detected. Do not show the error message.');
        }
    }
    
        render() {
            if (this.model.success && this.model.dataLoadingStatus==='Loaded') {
                this.renderResult();
            } else if (this.model.dataLoadingStatus!=='Initial' && this.model.dataLoadingStatus!=='Loading') {
                this.renderError();
            }
        }
        
        renderResources() {
            console.debug(`CommonSoftwareView: renderResources(): this.model.releaseVersion: ${this.model.releaseVersion}`);
            console.debug(this.elements);
            
            if (this.elements['resources'] && this.model.data.resources && this.model.releaseVersion) {
                IllumioDomUtils.removeChildren(this.elements['resources']);
                IllumioDomUtils.removeChildren(this.elements['resources-mobile']);
                
                const currentPage = this.getResourcePage();
                console.debug(`renderResources(): currentPage: ${currentPage}`);
                const resourcesForEachHandler = function(item) {
                    // SP-548
                    if ((item.version_display==this.model.releaseVersion || item.version_display==this.model.version.split('+')[0]) && (item.pages===null || item.pages==='' || item.pages.indexOf(currentPage)>=0)) {
                        var anchorTag = document.createElement('a');
                        anchorTag.href = item.url;
                        anchorTag.text = item.name;
                        var listTag = document.createElement('li');
                        listTag.appendChild(anchorTag);
                        this.elements['resources'].appendChild(listTag);
                        if (this.elements['resources-mobile']) {
                            this.elements['resources-mobile'].appendChild(listTag.cloneNode(true));
                        }
                    }
                }
                if (this.model.data.resources.length>0) {
                    if (this.elements['resources-mobile']) {
                        this.elements['resources-mobile'].appendChild(IllumioDomUtils.createSimpleTextBlock('h3', 'Resources', null));
                    }
                    this.model.data.resources.forEach(resourcesForEachHandler.bind(this));
                    this.elements['resources'].classList.remove('hidden');
                    this.elements['resources-mobile'].classList.remove('hidden');
                } else {
                    this.elements['resources'].classList.add('hidden');
                    this.elements['resources-mobile'].classList.add('hidden');
                }
            } else {
                console.error('Missing resourceElement, resource data and/or releaseVersion.');
            }
        }
        
        renderDownloads() {
            console.debug('CommonSoftwareView: renderDownloads()');
            
            if (this.elements['download'] && (this.model.data.software_components || this.model.archive_components)) {
                // this.renderDownloadsEvent.notify();
                this.emit('renderDownloads', {});
            }
        }
    
    getResourcePage() {
        var contentId = this.model.filename;
        switch(contentId) {
            case 'pce_software_download':
                return 'download_tar';
            case 'edge_download':
                return 'download_edge';
            case 'compatibility_matrix_download':
                return 'download_compatibility_matrix';
            case 'flowlink_download':
                return 'download_flowlink';
            case 'ven_download':
                return 'download_ven';
            case 'cli_download':
                return 'download_cli';
            case 'nen_download':
                return 'download_nen';
            case 'pce_software_upgrade':
                return 'upgrade_tar';
            case 'ven_upgrade':
                return 'upgrade_ven';
            default:
                return null;
        }
    }
}

export class CommonSoftwareController extends IllumioEventEmitter {
    constructor(model, view) {
        super();

        this.model = model;
        this.view = view;
        
        // this.view.renderDownloadsEvent.attach(renderDownloadsEventHandler.bind(this));
        this.view.on('renderDownloads', this.renderDownloadsEventHandler.bind(this));
       
        this.initializeAssetListing();
    }
    
    initializeAssetListing() {
        const assetListingModel = new AssetListingModel();
        const assetListingView = new AssetListingView(assetListingModel);
        assetListingView.downloadElement = this.view.elements['download'];
        assetListingView.eulaElement = this.view.elements['eula'];
        assetListingView.errorElement = this.view.elements['error'];
        this.assetListingController = new AssetListingController(assetListingModel, assetListingView);
    }
    
    renderDownloadsEventHandler() {
        console.debug('CommonSoftwareController: renderDownloadsEventHandler(): ');
        
        this.assetListingController.setModelData(this.model.metadata, this.model.data);
        this.assetListingController.view.render(this.model.displayVersions);
    }
}
